import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Snackbar,
  Alert,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState, useRef } from "react";
import ConfirmationDialog from "../../common/ConfirmationDialog";
import { AdminPreferencesService } from "../../services/adminPref.Service";
import EditIcon from "@mui/icons-material/Edit";

const useStyles = makeStyles({
  root: {
    "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus":
      {
        outline: "none",
      },
  },
});

export default function MaxVotingSetup(props) {
  const classes = useStyles();
  const { user } = props;
  const leagueOriginalData = useRef([]);
  const combineOriginalData = useRef([]);
  const [open, setConfirmationBoxOpen] = useState(false);
  const [eventType, setEventType] = useState("");
  const [combineYear, setCombineYear] = useState("");
  const [votes, setVotes] = useState("");
  const [eventTypeError, setEventTypeError] = useState(false);
  const [combineYearError, setCombineYearError] = useState(false);
  const [votesError, setVotesError] = useState(false);
  const [leagueDropdownData, setLeagueDropdownData] = useState([]);
  const [combineYearDropdownData, setCombineYearDropdownData] = useState([{}]);
  const [maxVotesSummary, setGridData] = useState([]);
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState("warning");
  const [alertMessage, setAlertMessage] = useState("");
  const [columnFlex, setColumnFlex] = useState(
    window.innerWidth >= 768 ? 1 : "none"
  );

  useEffect(() => {
    AdminPreferencesService.getLeagueNames().then((response) => {
      // console.log("League vlaue",response.data)
      response.data.forEach((item) => {
        leagueOriginalData.current.push({
          leagueId: item.leagueId,
          eventName: item.eventName,
        });
      });
      setLeagueDropdownData(leagueOriginalData.current);
    });
    AdminPreferencesService.getCombineNames().then((response) => {
      // console.log("Combine vlaue",response.data)
      response.data.forEach((item) => {
        combineOriginalData.current.push({
          leagueId: item.leagueId,
          EventId: item.eventId,
          combineYear: item.combineYear,
        });
      });
      setCombineYearDropdownData(combineOriginalData.current);
    });
    AdminPreferencesService.getAdminPrefMaxVoteDetails().then((response) => {
      let data = [];
      response.data.forEach((item) => {
        data.push({
          id: item.id,
          leagueId: item.leagueId,
          eventName: item.eventName,
          EventId: item.eventId,
          maxVoteCount: item.maxVoteCount,
          lastUpdatedDate: item.modifiedDate,
        });
      });
      setGridData(data);
    });

    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  const onResize = () => {
    setColumnFlex(window.innerWidth >= 768 ? 1 : "none");
  };

  const handleRowEditClick = (id) => {
    // console.log("maxVotesSummary",maxVotesSummary)
    const editData = maxVotesSummary.filter((elem) => elem.id === id);
    handleEventTypeChange(editData[0].leagueId);
    handleCombineYearChange(editData[0].EventId);
    setVotes(editData[0].maxVoteCount);
    setVotesError(false);
  };

  const handleEventTypeChange = (value) => {
    setEventType(value);
    setCombineYear("");

    AdminPreferencesService.getCombineNamesID(value).then((response) => {
      //console.log("Combine vlaue",response.data)

      setCombineYearDropdownData(response.data);
    });

    setEventTypeError(false);
  };

  const handleCombineYearChange = (value) => {
    setCombineYear(value);
    setCombineYearError(false);
  };

  const handleVotesChange = (e) => {
    if (e.target.value.length == 1 && e.target.value === "0") {
      e.preventDefault();
    } else {
      setVotes(e.target.value.replace(/\D/g, ""));
      setVotesError(false);
    }
  };

  const validateForm = () => {
    let isFormValid = false;
    if (eventType && combineYear && votes) {
      isFormValid = true;
    } else {
      setAlert(true);
      setAlertType("warning");
      setAlertMessage("All input fields are mandatory");
    }
    if (eventType) {
      setEventTypeError(false);
    } else {
      setEventTypeError(true);
    }
    if (combineYear) {
      setCombineYearError(false);
    } else {
      setCombineYearError(true);
    }
    if (votes) {
      setVotesError(false);
    } else {
      setVotesError(true);
    }
    return isFormValid;
  };

  const handleAlertClose = (e) => {
    setAlert(false);
  };

  const handleSubmitAction = () => {
    const isFormValid = validateForm();
    if (isFormValid) {
      setConfirmationBoxOpen(true);
    }
  };

  const handleConfirmationBoxClose = () => {
    setConfirmationBoxOpen(false);
  };

  const submitMaxVoteCount = (e) => {
    const isUpdate = maxVotesSummary.filter(
      (elem) => elem.leagueId === eventType && elem.EventId === combineYear
    ).length
      ? true
      : false;
    const formObj = {
      id: 0,
      EventId: combineYear,
      maxVoteCount: parseInt(votes),
      userBy: user.loginID,
    };
    AdminPreferencesService.insertUpdateAdminPrefBallotVoteCount(formObj).then(
      (response) => {
        setConfirmationBoxOpen(false);
        setAlert(true);
        setAlertType("success");
        if (isUpdate) {
          setAlertMessage("Record updated successfully");
        } else {
          setAlertMessage("Record created successfully");
        }
        setEventType("");
        setCombineYear("");
        setVotes("");
        AdminPreferencesService.getAdminPrefMaxVoteDetails().then(
          (response) => {
            let data = [];
            response.data.forEach((item) => {
              data.push({
                id: item.id,
                leagueId: item.leagueId,
                eventName: item.eventName,
                EventId: item.eventId,
                maxVoteCount: item.maxVoteCount,
                lastUpdatedDate: item.modifiedDate,
              });
            });
            setGridData(data);
          }
        );
      }
    );
  };

  return (
    <Box mt={2}>
      <Grid container rowSpacing={4} spacing={3}>
        <Grid item lg={3} md={4} sm={6} xs={12}>
          <FormControl size="small" error={eventTypeError} fullWidth>
            <InputLabel className={props.classes.root}>Event Type</InputLabel>
            <Select
              value={eventType}
              label="Event Type"
              onChange={(e) => {
                handleEventTypeChange(e.target.value);
              }}
            >
              {leagueDropdownData.map((elem, i) => {
                return (
                  <MenuItem key={i} value={elem.leagueId}>
                    {elem.eventName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item lg={2} md={2} sm={6} xs={12}>
          <FormControl size="small" error={combineYearError} fullWidth>
            <InputLabel className={props.classes.root}>Combine ID</InputLabel>
            <Select
              value={combineYear}
              label="Combine ID *"
              onChange={(e) => {
                handleCombineYearChange(e.target.value);
              }}
            >
              {combineYearDropdownData.map((elem, i) => {
                return (
                  <MenuItem key={i} value={elem.eventId}>
                    {elem.eventId}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item lg={2} md={2} sm={6} xs={12}>
          <FormControl size="small" fullWidth>
            <TextField
              label="Votes"
              placeholder="Please enter a number"
              size="small"
              error={votesError}
              value={votes}
              onChange={handleVotesChange}
            />
          </FormControl>
        </Grid>
        <Grid item xs="auto">
          <FormControl sx={{ marginTop: "4px" }}>
            <Button
              size="small"
              variant="contained"
              onClick={handleSubmitAction}
            >
              Save
            </Button>
            <ConfirmationDialog
              keepMounted
              open={open}
              onClose={handleConfirmationBoxClose}
              onSubmit={submitMaxVoteCount}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            className={classes.root}
            pageSize={10}
            rowHeight={38}
            headerHeight={35}
            autoHeight={true}
            rows={maxVotesSummary}
            columns={[
              { field: "id", hide: true, flex: 1 },
              { field: "leagueId", hide: true, flex: 1 },
              {
                field: "eventName",
                headerName: "Event Type",
                width: 150,
                flex: columnFlex,
              },
              {
                field: "EventId",
                headerName: "Combine ID",
                width: 150,
                flex: columnFlex,
              },
              {
                field: "maxVoteCount",
                headerName: "Max Votes",
                width: 150,
                flex: columnFlex,
              },
              {
                field: "lastUpdatedDate",
                headerName: "Last Updated Date",
                width: 150,
                flex: columnFlex,
              },
              {
                field: "actions",
                type: "actions",
                headerName: "Action",
                width: 100,
                cellClassName: "actions",
                getActions: ({ id }) => {
                  return [
                    <div title="Edit">
                      <EditIcon
                        sx={{
                          marginTop: "8px",
                          fontSize: "1.5rem",
                          cursor: "pointer",
                          color: "#1d428a",
                        }}
                        className="action-edit-button"
                        onClick={() => {
                          handleRowEditClick(id);
                        }}
                      />
                    </div>,
                  ];
                },
              },
            ]}
            disableSelectionOnClick
            disableColumnSelector
            getCellClassName={(params) => {
              if (params.field !== "actions") {
                return `admin-pref-grid-cells`;
              }
            }}
            components={{
              NoRowsOverlay: () => (
                <Box
                  sx={{
                    position: "absolute",
                    marginTop: "82px",
                    marginLeft: "45%",
                  }}
                >
                  No Rows
                </Box>
              ),
              NoResultsOverlay: () => (
                <Box
                  sx={{
                    position: "absolute",
                    marginTop: "82px",
                    marginLeft: "45%",
                  }}
                >
                  No Results Found
                </Box>
              ),
            }}
          />
        </Grid>
        <Snackbar
          open={alert}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={3000}
          onClose={handleAlertClose}
        >
          <Alert
            onClose={handleAlertClose}
            severity={alertType}
            sx={{ width: "100%" }}
          >
            {alertMessage}
          </Alert>
        </Snackbar>
      </Grid>
    </Box>
  );
}
